import { ChannelType } from '@/models/channel.model';

export const headerColorsMap = {
  [ChannelType.PARTS]: {
    background: 'colorPrimary',
    color: 'colorTextBase',
  },
  [ChannelType.PRODUCTS]: {
    background: 'colorBgSecondary',
    color: 'colorTextSecondary',
  },
  [ChannelType.SHOWCASE]: {
    background: 'colorTextSecondary',
    color: 'colorPrimary',
  },
};

export const getHeaderThemeColors = (channelType?: ChannelType) => {
  return headerColorsMap[channelType || ChannelType.PRODUCTS];
};
